export const INTEGER_TYPE = 'number';
export const STRING_TYPE = 'text';
export const DATE_TYPE = 'date';
export const CURRENCY_TYPE = 'currency';
